module.exports = __webpack_public_path__ + "static/media/slider3.cba376cb.png";